import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {history, TIPO_CONVERSACION} from "../../_helpers";
import {ConsultaModal} from "../publica/utils/ConsultaModal";
import {Modal} from "react-bootstrap";

class Footer extends React.Component {
    constructor(props) {
        super(props);
    }

    state = {
        showConsulta: false
    }

    handleClose = () => {
        this.setState({showConsulta: false});
    }

    abrirModalMensaje = () => {
        this.setState({showConsulta: true});
    }

    render() {
        return (
            <>
                <footer className="footer">
                    <div className="container__dap">
                        <div className="grid-auto-fit ">
                            {/* <div>
                <h2>LOGO</h2>
                <ul>
                  <li>
                    
                    <a href="">Login</a>
                  </li>
                  <li>
                    
                    <a href=""> Registrarse </a>
                  </li>
                </ul>
              </div> */}
                            <div>
                                <h4>EMPRESA</h4>
                                <ul>
                                    {/* <li>
                    <a href=""> Misión</a>
                  </li>
                  <li>
                    <a href=""> Objetivos</a>
                  </li> */}
                                    <li>
                                        <a onClick={() => {
                                            history.push("/sobre-nosotros");
                                            window.scrollTo(0, 0);
                                        }}> Sobre Nosotros</a>
                                    </li>
                                    {/* <li>
                    <a href=""> FAQ</a>
                  </li> */}
                                </ul>
                            </div>
                            <div>
                                <h4>CONTACTO</h4>
                                <ul className="footer__social">
                                    <li>
                                        <a onClick={() => this.abrirModalMensaje()}>
                      <span>
                        <FontAwesomeIcon icon="fa-regular fa-envelope"/>
                      </span>
                                            Contactanos
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://instagram.com/deautopartes.ar" target="_blank">
                      <span>
                        <FontAwesomeIcon icon="fa-brands fa-instagram"/>
                      </span>
                                            @deautopartes.ar
                                        </a>
                                    </li>
                                    <li>
                                        <a href="">
                      <span>
                        <FontAwesomeIcon icon="fa-brands fa-facebook-f"/>
                      </span>
                                            deautopartes
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="footer__terms">
                        <div className="container__dap">
                            <div className="footer__terms-container">
                                <a onClick={() => {
                                    history.push("/terminos-condiciones");
                                    window.scrollTo(0, 0);
                                }}>Terminos de uso</a>
                                <a onClick={() => {
                                    history.push("/politica-privacidad");
                                    window.scrollTo(0, 0);
                                }}>Copyright <FontAwesomeIcon icon="fa-regular fa-copyright"/></a>
                                <a href="#"> Hecho por deautopartes</a>
                            </div>
                        </div>
                    </div>
                </footer>

                <Modal size="md" show={this.state.showConsulta} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        Envianos un mensaje
                    </Modal.Header>
                    <Modal.Body>
                        <ConsultaModal
                            handleClose={this.handleClose}
                            type={TIPO_CONVERSACION.GENERAL}
                        />
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

export default Footer;
